// src/features/account/api/editAccountDetails.js
import { axios } from 'lib/axios';
import { queryClient } from 'lib/react-query';
import { useMutation } from 'react-query';
import { useNotificationStore } from 'stores/notifications';

export const editAccountDetails = (data) => {
  return axios.patch('/users/profile', data);
};

export const useEditAccountDetails = ({ config } = {}) => {
  const { addNotification } = useNotificationStore();

  return useMutation({
    mutationFn: editAccountDetails,
    onSuccess: () => {
      queryClient.invalidateQueries('user');
      addNotification({
        type: 'success',
        title: 'Account details updated',
      });
    },
    onError: () => {
      addNotification({
        type: 'error',
        title: 'Update failed',
        message: 'Could not update your account details. Please try again.',
      });
    },
    ...config,
  });
};
